import type { ComboWeatherSnapshot } from '../../db';

/**
 * Human-readable one-line summary of a captured weather snapshot for read-back.
 * Categories are already human-readable strings. Returns '—' when the snapshot
 * is missing or partial (any of the three categories absent).
 */
export function describeWeather(w?: ComboWeatherSnapshot): string {
  if (!w || !w.temperatureCategory || !w.windCategory || !w.precipitationCategory) return '—';
  return `${w.temperatureCategory} · ${w.windCategory} · ${w.precipitationCategory}`;
}
